export const WalletBalancesSkeleton = ({ length }: { length: number }) => {
    return (
        <div className='flex gap-4 overflow-auto'>
            {Array(length)
                .fill(1)
                .map((_, index) => (
                    <div
                        role='status'
                        key={index}
                        className='flex items-center justify-center h-[172px] w-[208px] px-6 py-5 rounded-[24px] border border-appcolorfaintnine bg-lightGray rounded-lg animate-pulse'
                    >
                        <span className='sr-only'>Loading...</span>
                    </div>
                ))}
        </div>
    );
};
